import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { ServiceService } from '../services/service.service';
import { ActivatedRoute } from '@angular/router';
import { Service } from '../models/service';

@Component({
  selector: 'asv-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  service: Service;

  constructor(
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private serviceService: ServiceService
  ) {
    this.loadingService.show();
    const id = route.snapshot.params['id'];
    serviceService.getService(id);
    serviceService.service.subscribe((item: Service) => {
      this.service = item;
    });
  }

  ngOnInit() {
  }

}
